import type { AuditLogType } from "../types";

// TODO: Fix this the next time the file is edited
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dbToLogs(serverLogs: any[]): AuditLogType[] {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return serverLogs.map((serverLog: any) => ({
    event: serverLog.event || ".",
    timestamp: serverLog.timestamp,
    timestampString: new Date(serverLog.timestamp * 1000).toLocaleString(),
    resource: serverLog.resource || {},
    invitedUsers: serverLog.invitedUsers || [],
    authentication: serverLog.authentication || {},
    page: serverLog.page || {},
    application: serverLog.application || {},
    workspace: serverLog.workspace || {},
    environment: serverLog.environment || {},
    datasource: serverLog.datasource || {},
    user: serverLog.user || {},
    license:
      {
        ...serverLog.license,
        ...(serverLog.license?.expiry && {
          expiry: new Date(
            Number(serverLog.license.expiry) * 1000,
          ).toLocaleString(),
        }),
      } || {},
    userGroup: serverLog.group || {},
    permissionGroup: serverLog.role || {},
    instanceSettings: serverLog.instanceSettings || [],
    metadata: serverLog.metadata || {},
    userPermissions: serverLog.userPermissions || [],
    id: serverLog.id || -1 /* mongodb record id */,
  }));
}
